"use client";

import type { ISbStoryData, SbBlokData } from "@storyblok/react/rsc";
import { useGlobalDataContext } from "@/components/GlobalDataContext";

export const useGlobalComponentData = (
  globalComponent: string | SbBlokData,
): ISbStoryData | null => {
  const { globalComponentsStories } = useGlobalDataContext();

  if (!globalComponent) return null;

  const globalComponentData = globalComponentsStories.find(
    (s) => s.uuid === globalComponent,
  );

  return globalComponentData || null;
};
